import { useEffect } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { getDownloadedPdfUsers } from '../../actions/downloadedPdfUsers';
import styles from './DownloadedPdfUsers.module.css';

const DownloadedPdfUsers = (props) => {
  const { 
    getDownloadedPdfUsers, 
    downloadedPdfUsersData,
  } = props;

  useEffect(() => {
    getDownloadedPdfUsers();
  }, []);

  const exportToCSV = () => {
    if (!downloadedPdfUsersData || downloadedPdfUsersData.length === 0) {
      return;
    }

    // Define CSV headers
    const headers = ['Id', 'Email', 'Date Downloaded'];
    
    // Convert data to CSV rows
    const rows = downloadedPdfUsersData.map(user => [
      user.id,
      user.email,
      user.date_downloaded ? new Date(user.date_downloaded).toLocaleString() : '',
    ]);

    // Combine headers and rows
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n');

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `pdf_downloads_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="wrapper">
      <div className={styles.tools}>
        <h1>
          PDF Downloads
        </h1>
        <div className={styles.buttons}>
          <div className={styles.exportButton} onClick={exportToCSV}>
            Export CSV
          </div>
        </div>
      </div>
      <table className={cn(styles.table, 'table')}>
        <thead>
          <tr>
            <th>Id</th>
            <th>Email</th>
            <th>Date Downloaded</th>
          </tr>
        </thead>
        <tbody>
          {downloadedPdfUsersData?.map((user) => (
            <tr key={user.id}>
              <td>
                {user.id}
              </td>
              <td>
                {user.email}
              </td>
              <td>
                {user.date_downloaded ? new Date(user.date_downloaded).toLocaleString() : '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (store) => ({
  downloadedPdfUsersData: store.downloadedPdfUsers.downloadedPdfUsersData,
});

const mapDispatchToProps = {
  getDownloadedPdfUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadedPdfUsers);
